import { Component, computed, effect, input, model, output, signal } from '@angular/core';
import { LotSaisiesRevendications } from 'src/app/data/declaration/models/lot-saisies-revendications.model';
import { SaisieRevendication } from 'src/app/data/declaration/models/saisie-revendication.model';
import { SaisieRevendicationResult } from 'src/app/data/declaration/interfaces/saisie-revendication-result.interface';
import { MouvementsProduitsService } from 'src/app/data/declaration/services/mouvements/mouvements-produits.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FacturationService } from 'src/app/data/facturation/services/facturation/facturation.service';
import { ModeleFacturationService } from 'src/app/data/facturation/services/modele-facturation/modele-facturation.service';
import { ModeleFacturationLight } from 'src/app/data/facturation/models/modele-facturation-light.model';
import { ProduitsService } from 'src/app/data/habilitation/services/produits/produits.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { Column } from '../../../../../../../../shared/models/column.model';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-synthese-saisie-revendication',
    templateUrl: './synthese-saisie-revendication.component.html',
    styleUrls: ['./synthese-saisie-revendication.component.scss'],
    imports: [FormsModule, Dialog, TranslateModule, PrimeTemplate, TableModule, FloatLabel, InputText, DatePickerModule, Button, TooltipModule],
    standalone: true
})
export class SyntheseSaisieRevendicationComponent {
    readonly lotRevendications = input<LotSaisiesRevendications>();
    readonly creerRevendication = input<boolean>(false);
    visible = model<boolean>(false);
    readonly fermerModale = output<SaisieRevendicationResult | null>();
    readonly numeroDossier = signal<string | null>(null);
    readonly dateLot = computed(() => this.lotRevendications()?.date?.toDate() ?? null);

    facturationDirecte: ModeleFacturationLight[] = [];

    readonly columns: Column[] = [
        { field: 'libelleProduit', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.produit' },
        { field: 'numeroLot', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.numeroLot' },
        { field: 'degre', label: 'page.declarations.synthese.modal.saisir-revendication.degre' },
        { field: 'cepages', label: 'page.declarations.synthese.modal.saisir-revendication.cepages' },
        { field: 'logement', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.logement' },
        { field: 'volume', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.volume' },
        { field: 'destinations', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.destinations' },
        { field: 'labels', label: 'page.declarations.synthese.modal.synthese-saisies-revendications.table.header.labels' },
        { field: 'observation', label: 'page.declarations.synthese.modal.saisir-revendication.observation' }
    ];

    constructor(
        private readonly mouvementsProduitsService: MouvementsProduitsService,
        private readonly translate: TranslateService,
        private readonly toastr: ToastrService,
        private readonly modelefacturationService: ModeleFacturationService,
        private readonly produitService: ProduitsService,
        private readonly facturationService: FacturationService,
        private readonly loaderService: LoaderService
    ) {
        effect(() => {
            const lot = this.lotRevendications();
            if (this.visible() && lot) {
                this.numeroDossier.set(null);
                this.facturationDirecte = [];
                const codeproduit = lot.revendications[0].codeProduit;
                this.produitService.getProduitByCode(codeproduit).subscribe(produit => {
                    this.modelefacturationService.facturationDirecte('REVENDICATION_IGP', produit.idCahier).subscribe(modelefacturations => {
                        this.facturationDirecte = modelefacturations;
                    });
                });
            }
        });
    }

    onAddSaisie() {
        this.fermerModale.emit({
            saisieTerminee: false,
            lotRevendications: this.lotRevendications(),
            indexAModifier: undefined
        });
        this.visible.set(false);
    }

    onClose(estTermine: boolean = false) {
        this.fermerModale.emit(estTermine ? { saisieTerminee: true, lotRevendications: undefined, indexAModifier: undefined } : null);
        this.visible.set(false);
    }

    onDelete(index: number) {
        const lot = this.lotRevendications();
        if (lot && lot.revendications.length > 1) {
            lot.revendications.splice(index, 1);
        }
    }

    onEdit(index: number) {
        this.fermerModale.emit({
            saisieTerminee: false,
            lotRevendications: this.lotRevendications(),
            indexAModifier: index
        });
        this.visible.set(false);
    }

    onSubmit() {
        const lot = this.lotRevendications();
        if (this.creerRevendication()) {
            if (this.facturationDirecte.length > 0) {
                this.mouvementsProduitsService.creerLotRevendicationsAvantFacture(lot).subscribe(objetFactures => {
                    const idObjets = [];

                    objetFactures.forEach(o => {
                        if (!idObjets.includes(o.idObjet)) {
                            idObjets.push(o.idObjet);
                        }
                    });

                    this.mouvementsProduitsService
                        .getNumeroDossier(idObjets)
                        .pipe(this.loaderService.operator())
                        .subscribe(numDossier => {
                            this.facturationService
                                .postFacturationAfterMouvement(this.facturationDirecte[0].id, objetFactures, numDossier.join())
                                .pipe(this.loaderService.operator())
                                .subscribe(reponse => {
                                    this.translate.get('page.declarations.synthese.modal.synthese-saisies-revendications.facture-ok').subscribe(msg => {
                                        this.toastr.success('', msg);
                                    });
                                    window.open(reponse, '_blank');
                                    this.fermerModale.emit({ saisieTerminee: true, lotRevendications: undefined, indexAModifier: undefined });
                                    this.visible.set(false);
                                });
                        });
                });
            } else {
                this.mouvementsProduitsService.creerLotRevendications(lot).subscribe(numeroDossier => {
                    this.numeroDossier.set(numeroDossier);
                    this.translate.get('page.declarations.synthese.modal.synthese-saisies-revendications.lot-ok').subscribe(msg => {
                        this.toastr.success('', msg);
                    });
                });
            }
        } else {
            lot.revendications.forEach(rev => {
                rev.millesime = lot.campagne;
            });

            this.mouvementsProduitsService.majLotRevendications(lot).subscribe(numeroDossier => {
                this.numeroDossier.set(numeroDossier);
                this.translate.get('page.declarations.synthese.modal.synthese-saisies-revendications.maj-lot-ok').subscribe(msg => {
                    this.toastr.success('', msg);
                });
            });
        }
    }

    getCepages(saisie: SaisieRevendication): string {
        const lot = this.lotRevendications();
        return saisie.cepages && lot?.referentiels?.cepages
            ? lot.referentiels.cepages
                  .filter(cepage => saisie.cepages.find(c => c === cepage.id))
                  .map(cepage => cepage.libelle)
                  .join(', ')
            : '';
    }

    getEnvironnementLabels(saisie: SaisieRevendication): string {
        const lot = this.lotRevendications();
        const libelles: string[] = lot?.referentiels?.environnementLabels
            ? lot.referentiels.environnementLabels.filter(label => saisie.environnementLabels?.includes(label.id)).map(label => label.libelle)
            : [];
        if (saisie.autresEnvironnementLabels?.trim()) {
            libelles.push(saisie.autresEnvironnementLabels.trim());
        }
        return libelles.join(', ');
    }

    getDestinations(saisie: SaisieRevendication): string {
        const lot = this.lotRevendications();
        return saisie.destinations && lot?.referentiels?.mouvementsDestinations
            ? lot.referentiels.mouvementsDestinations
                  .filter(destination => saisie.destinations.find(d => d === destination.id))
                  .map(destination => destination.libelle)
                  .join(', ')
            : '';
    }
}
